import { Nullable } from "common/types";
import { Record } from "immutable";

export const commissionTestDataFromJSON = (json: Partial<ICommissionTestDataData>): CommissionTestDataRecord => {
  const recordData: ICommissionTestDataRecord = { ...(json as any) };

  return new CommissionTestDataRecord(recordData);
};

export interface ICommissionTestDataData {
  job_id: Nullable<number>;
  estimate_id: Nullable<number>;
}

export interface ICommissionTestDataRecord {
  job_id: Nullable<number>;
  estimate_id: Nullable<number>;
}

export const defaultCommissionTestDataProps: ICommissionTestDataRecord = {
  job_id: null,
  estimate_id: null,
};

export class CommissionTestDataRecord
  extends Record(defaultCommissionTestDataProps)
  implements ICommissionTestDataRecord {}
